import './index.scss';

const $context = '.q-profile-page';
const $notebooksContext = $('.q-notebooks-card-list', $context);

$('.q-notebooks-type-1', $notebooksContext).addClass('q-product-active');

function cleanFilter() {
  $('.q-notebooks-card-list', $context).find('.q-notebooks-list').removeClass('q-product-active');
}

function filterNotebooks (notebookType) {
  const $context = $('.q-notebooks-list-container');
  $(notebookType, $context).addClass('q-product-active');
}

$('.js-filter-notebooks', $context).change(function() {
  const value = `q-product-value-${$('.js-filter-notebooks').val()}`;

  const $enem = $('.q-notebooks-type-3', $notebooksContext);
  const $militar = $('.q-notebooks-type-5', $notebooksContext);
  const $oab = $('.q-notebooks-type-7', $notebooksContext);
  const $exam = $('.q-notebooks-type-9',$notebooksContext);
  const $publicContest = $('.q-notebooks-type-1', $notebooksContext);

  cleanFilter();
  switch (value) {
    case 'q-product-value-3':
      filterNotebooks($enem);
      break;
    case 'q-product-value-5':
      filterNotebooks($militar);
      break;
    case 'q-product-value-7':
      filterNotebooks($oab);
      break;
    case 'q-product-value-9':
      filterNotebooks($exam);
      break;
    default:
      filterNotebooks($publicContest);
      break;
  }
});

